import * as ko from "knockout";
import entityBase from "entityBase";

export class contact extends entityBase {
  contact_type: KnockoutObservable<string>;
  email_address: KnockoutObservable<string>;
  first_name: KnockoutObservable<string>;
  last_name: KnockoutObservable<string>;
  phone: KnockoutObservable<string>;
  product_reference_count: KnockoutObservable<number>;

  constructor(item: any) {
    super();
    this.contact_type = ko.observable(item.contact_type).extend({ maxLength: 128 });
    this.email_address = ko.observable(item.email_address).extend({ maxLength: 128 });
    this.first_name = ko.observable(item.first_name).extend({ maxLength: 64 });
    this.last_name = ko.observable(item.last_name).extend({ maxLength: 128 });
    this.phone = ko.observable(item.phone).extend({ maxLength: 32 });
    this.product_reference_count = ko.observable(item.product_reference_count);
  }
}
